module.exports = __webpack_public_path__ + "media/images/front/icons/drvideos-9ef12e83807262809946f48afd88604c.png";